import { Directive, HostListener, Input } from '@angular/core'
import {EventService, WindowRef} from '@spartacus/core'
import {AnalyticsEvent} from '../../analytics/events/analytics.event';
import {MbConstants} from '../mb-constants';

@Directive({
  selector: '[mbCopyToClipboard]',
})
export class MbCopyToClipboardDirective {

  @Input('mbCopyToClipboard') text: string = ''

  @HostListener('click')
  private onClick () {
    if (!this.winRef.isBrowser() || !this.winRef.nativeWindow?.navigator?.clipboard?.writeText) {
      return console.error('Clipboard API not supported')
    }
    this.winRef.nativeWindow.navigator.clipboard.writeText(this.text)
    this.events.dispatch(new AnalyticsEvent(MbConstants.PRODUCT_SKU, MbConstants.COPY_SKU, this.text))
  }

  constructor (private winRef: WindowRef, private events: EventService) {
  }
}
